/* global axios */
import ApiClient from '../ApiClient';

class ChatlottaIndustryTemplatesAPI extends ApiClient {
  constructor() {
    super('chatlotta/industry_templates', { accountScoped: true });
  }

  getTemplates() {
    return axios.get(this.url);
  }
}

export default new ChatlottaIndustryTemplatesAPI();
